document.addEventListener("DOMContentLoaded", function () {
  /* Woocommerce - plus / minus quantity buttons */
  document.addEventListener('click', function (event) {
    if (!event.target.matches('button.plus, button.minus')) return; //extending the current woo function for this to update the custom mobile select dropdown 

    event.preventDefault();
    var qtyChange = event.target;
    var qtyWrapper = qtyChange.parentNode;
    var qty = qtyWrapper.querySelector('.qty');
    var val = parseFloat(qty.value);
    var max = parseFloat(qty.getAttribute('max'));
    var min = parseFloat(qty.getAttribute('min'));
    var step = parseFloat(qty.getAttribute('step'));

    if (qtyChange.classList.contains('plus')) {
      // Change the value if plus or minus
      if (max && max <= val) {
        qty.value = max;
      } else {
        qty.value = val + step;
      }
    } else {
      if (min && min >= val) {
        qty.value = min;
      } else if (val > 1) {
        qty.value = val - step;
      }
    }
  }, false);
});